<template>
  <default-textual-section v-if="$store.state.displayType === 'textual'" :menu="menu" :section="section"
                           :menu-item-component="menuItemComponent"
                           class="menu--section-easter">
    <template v-slot:sectionTitleImage>
      <h2 class="menu--section-title-easter">
        <img src="/library/images/menu/easter-title-2026.png" alt="Easter Dining" class="menu--section_logo">
      </h2>
    </template>
  </default-textual-section>
  <default-visual-section v-else :menu="menu" :section="section"
                          :menu-item-component="menuItemComponent"
                          class="menu--section-easter">
    <template v-slot:sectionTitleImage>
      <h2 class="menu--section-title-easter">
        <img src="/library/images/menu/easter-title-2026.png" alt="Easter Dining" class="menu--section_logo">
      </h2>
    </template>
  </default-visual-section>
</template>

<script lang="ts">
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 0.1.0
 * @copyright  Copyright (C) 2025-2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2025-4-09 (1.0.0) (jhoward)
 *    - Copy from ValentinesDay_defaultSection.vue component to Easter_defaultSection.vue component.
 * @changelog
 *
 * 2026-07-20 (0.1.0) (jhoward)
 *   - Update App\Library\Js\Components\Menu\Section\Easter_defaultSection.vue to use new Easter 2026 title image and background, adjust layout and responsive styles.
 */

import {defineComponent, PropType} from "vue";
import { ALLOWED_ITEM_COMPONENTS, Menu, MenuSection } from "../defs";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";

export default defineComponent({
  components: {
    DefaultVisualSection, DefaultTextualSection,
  },
  name: "Easter_defaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menuVersion: {
      type: String,
      default: ''
    },
    sectionModifier: {
      type: String,
      default: ''
    },
    menu: {
      type: Object as PropType<Menu | null>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: '',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
  },
  mounted() {
    this.section.ms_title = this.sectionTitle();
    this.section.ms_subtitle = this.sectionSubtitle();
  },
  data: function () {
    return {};
  },
  methods: {
    sectionTitle(): string {
      const output = this.section.ms_title;
      if ('easter dining menu' === output.toLowerCase()) {
        return 'EASTER DINING';

      }
      if (output.length) {
        return output.replace(/-/g, '<span class="menu--title_hyphen">-</span>');
      }

      return 'DINING';
    },
    sectionSubtitle(): string {
      if (this.section.ms_subtitle.length) {
        return this.section.ms_subtitle.replace(/-/g, '<span class="menu--title_hyphen">-</span>');
      }

      return (this.menu?.page?.page_h1 || '').toUpperCase();
    },
  }
})
</script>

<style scoped>
.menu--section-easter {
  font-size: 1.4em;
  color: #231f20;
  text-align: center;
  padding-left: 15rem !important;;
  padding-bottom: 10rem;
  padding-right: 15rem !important;;
}

@media (max-width: 950px) {
  .menu--section-easter {
    padding-left: 12rem !important;
    padding-right: 12rem !important;;
  }
}

@media (max-width: 800px) {
  .menu--section-easter {
    padding-left: 6rem !important;;
    padding-right: 6rem !important;;
  }
}

@media (max-width: 600px) {
  .menu--section-easter {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media (max-width: 400px) {
  .menu--section-easter {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.menu--section-easter::before {
  content: '';
  position: absolute;
  z-index: -2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('/library/images/menu/background-easter-2026.jpg');
  background-size: cover;
  background-position: top center;

}
.menu--container-the_steak_house .menu--section-easter::before {
  visibility: visible;
  opacity: 1;
  padding-left: 0;
}

.menu--section_logo {
  width: 60%;
  max-width: 400px;
  margin-top: 10rem;
}

.visual_menu--section .menu--section_logo {
  margin-top: 0;
}

/*.menu--section-easter::after {
  content: '';
  position: absolute;
  z-index: -2;
  top: 10rem;
  left: 3em;
  right: 3em;
  bottom: 3em;
  background-color: #FFF;
}*/

.menu--section-easter:deep(.menu--highlight-easter) {
  /*color: #ed2030;*/
  font-weight: bold;
}

.menu--section-easter:deep(.menu--item_description strong) {
  font-size: 1.2em;
}

.menu--section-easter:deep(.menu--item_description p) {
  margin-top: 0;
  margin-bottom: 0;
}

.menu--section-easter:deep(.menu--item_title-easter) {
  font-size: 1.2em;
}

h2 {
  padding-left: 0;
}

h2 img {
  width: 83%;
}

.menu--section-easter:deep(.menu--section_title) {
  display: none;/*
  font-family: itc-avant-garde-gothic-pro, sans-serif;
  letter-spacing: 0.1em;
  font-weight: 300;
  font-size: 2em;
  transform: scaleY(0.85);
  border-top: 0.4rem dotted #ffc523;
  padding: 0.7em 0.5em 0;
  margin-top: 0.4em;*/
}

.menu--section-easter:deep(.menu--section_subtitle) {
  text-align: center;
  font-family: trajan-pro-3, serif;
  font-size: 1.6em;
  width: 80%;
  margin: 0.3em auto 0;
  line-height: 1em;
  letter-spacing: 0.1em;
  font-weight: bold;
  color: #000;
}

/*.menu--section-easter:deep(.visual_menu--page_section-top) {
  border-bottom: 0.4rem dotted #ffc523;
  max-width: 500px;
  margin: 0 auto;
}*/

.menu--section-easter:deep(.visual_menu--page_section-top p) {
  margin-top: 0;
  margin-bottom: 0;
}

.menu--section-easter:deep(.visual_menu--page_section-top p:first-child) {
  font-weight: bold;
}

.menu--section-easter:deep(.menu--page_section-bottom .menu--page_section-bottom) {
  padding-top: 1.25em;
  position: relative;
}

/*.menu--section:deep(.menu--page_section-bottom .menu--page_section-bottom::before) {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  width: 60%;
  height: 0.125em;
  transform: translateX(-50%);
  background-color: #ed2030;
}*/

.menu--section-easter:deep(.menu--item_title) {
  /*color: #df2b54;*/
  font-size: 1em;
}

.menu--section-easter:deep(.menu--item_subgroup .menu--item) {
  display: block;
}

.menu--section-easter:deep(.menu--page_content-top) {
  position: relative;
  padding-top: 4rem;
  padding-bottom: 1.2rem;
}

.menu--section-easter:deep(.visual_menu--page_section-top) {
  position: relative;
  padding-top: 4rem;
}

.menu--section-easter:deep(.menu--page_content-top::before),
.menu--section-easter:deep(.menu--page_content-top::after),
.menu--section-easter:deep(.visual_menu--page_section-top::before),
.menu--section-easter:deep(.visual_menu--page_section-top::after) {
  content: '';
  position: absolute;
  height: 0;
  width: 70%;
  top: 2.2rem;
  left: 15%;
  border-top: 0.3em dotted #df2b54;
}

.menu--section-easter:deep(.menu--page_content-top::after),
.menu--section-easter:deep(.visual_menu--page_section-top::after) {
  top: auto;
  bottom: 0;
}
</style>